enum ThemeMode {
  DARK = 'dark',
  LIGHT = 'light',
}

export default ThemeMode;
